import React from 'react';
import { ShieldCheck, Star } from 'lucide-react';
export function HeroSection() {
  const handleCTAClick = () => {
    // Fire Meta Pixel AddToCart event
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'AddToCart');
    }
    // Redirect to Shopify checkout
    window.location.href = 'https://www.tubienestarinterno.com/cart/53346355937617:1';
  };
  return <section className="pt-12 pb-16 px-4 bg-white" data-id="element-77">
      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-center" data-id="element-78">
        {/* Mobile: Image usually goes first or center, but we'll follow standard flow (text then image, or image then text). Let's put text first for immediate hook, image center on mobile. */}
        <div className="order-2 md:order-1 flex flex-col items-center md:items-start text-center md:text-left" data-id="element-79">
          <div className="inline-flex items-center space-x-1 bg-brand-gold-light text-yellow-800 px-3 py-1 rounded-full text-xs font-bold mb-6 tracking-wide uppercase" data-id="element-80">
            <ShieldCheck className="w-4 h-4 mr-1" data-id="element-81" />
            Ciencia Aplicada a la Conducta Canina
          </div>

          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold leading-tight mb-4" data-id="element-82">
            CIENCIA APLICADA A LA CONDUCTA CANINA: ¿Su perro se bloquea, ignora
            sus llamados o entra en pánico al pisar la calle?
          </h1>

          <p className="text-gray-600 mb-8 text-base sm:text-lg leading-relaxed" data-id="element-83">
            Active el INTERRUPTOR NEUROLÓGICO de calma en 7 días. Silencie el
            exceso de cortisol y recupere el control sin tirones y sin gritos.
          </p>

          <button onClick={handleCTAClick} className="w-full md:w-auto bg-brand-teal hover:bg-brand-teal-dark text-white font-semibold py-3 px-6 rounded-[20px] shadow-lg transition-all transform hover:scale-105 text-sm sm:text-base" data-id="element-84">
            SÍ, DESEO EL PROTOCOLO COMPLETO - $9.95 USD
          </button>

          <div className="mt-6 flex flex-col sm:flex-row items-center justify-center md:justify-start space-y-2 sm:space-y-0 sm:space-x-4 text-sm text-gray-500 font-medium" data-id="element-85">
            <span className="flex items-center" data-id="element-86">
              <ShieldCheck className="w-4 h-4 mr-1 text-brand-teal" data-id="element-87" /> Pago
              único.
            </span>
            <span className="flex items-center" data-id="element-88">
              <ShieldCheck className="w-4 h-4 mr-1 text-brand-teal" data-id="element-89" /> Acceso
              inmediato.
            </span>
            <span className="flex items-center" data-id="element-90">
              Valoración real 4.9/5
              <div className="flex ml-1" data-id="element-91">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 text-brand-gold fill-brand-gold" data-id="element-92" />)}
              </div>
            </span>
          </div>
        </div>

        <div className="order-1 md:order-2 flex justify-center relative" data-id="element-93">
          {/* MOCKUP NUEVO (Product Pack) */}
          <div className="relative w-full max-w-md" data-id="element-94">
            <img src="https://cdn.magicpatterns.com/uploads/h4nX1CK9HnX9YFutro1y63/mockup_nuevo.png" alt="Pack Completo Digital DOG-CALM" className="w-full h-auto rounded-[20px] shadow-2xl" data-id="element-95" />
            {/* Decorative glassmorphism elements */}
            <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-brand-gold rounded-full opacity-20 blur-2xl" data-id="element-96"></div>
            <div className="absolute -top-4 -left-4 w-32 h-32 bg-brand-teal rounded-full opacity-20 blur-2xl" data-id="element-97"></div>
          </div>
        </div>
      </div>
    </section>;
}